import { Button, Spin } from 'antd';
import { billingSelectors, workSpaceSelectors } from 'containers/App/selectors';
import { Formik } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { setLoadStep2 } from 'pages/BillingProcess/slices';
import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { t_medical_institution } from 'types';
import { getListOtherDetail, updateOtherDetail } from '../../BillingProcess/thunk';
import TableDataUser from './TableDataUser';
import { Wrapper } from './styles';

type Props = {
  nextStep: () => void;
  stepToPrevious: () => void;
};
type LocationState = {
  medicalDetail: t_medical_institution;
};

type InitialValues = {
  detail_name: any;
  other_detail_count: string;
  other_detail_unit_price: string;
  other_detail_remark: string;
  position?: number;
};

const BillingOtherFiveStep: FC<Props> = ({ nextStep, stepToPrevious }) => {
  const dispatch = useDispatch();
  const location = useLocation<LocationState>();
  const { itemInvoice, otherDetail, loadStep2 } = useSelector(billingSelectors);
  const { statusBill } = useSelector(workSpaceSelectors);

  const [listNew, setListNew] = useState<any>([]);

  useEffect(() => {
    dispatch(setLoadStep2(true));
    dispatch(
      getListOtherDetail({
        invoice_id: itemInvoice?.invoice_id ?? '',
      }),
    );
  }, [dispatch, location, itemInvoice]);

  const handleSubmit = (value: InitialValues, form: any) => {
    form.setSubmitting(false);
    setListNew((oldState: any) => [...oldState, { ...value, position: oldState.length + 1 }]);
    form.resetForm();
  };

  const handleSubmitOther = async (statusBill: boolean | undefined) => {
    if (listNew && !statusBill) {
      const params: any = {
        invoice_month: itemInvoice?.invoice_month,
        facility_id: location.state.medicalDetail.i_id,
        invoice_id: itemInvoice?.i_id,
        return_item_result: true,
        newData: listNew,
      };
      const result: any = await dispatch(updateOtherDetail(params));
      if (result.payload.error) return;
    }

    dispatch(
      getListOtherDetail({
        invoice_id: itemInvoice?.invoice_id ?? '',
      }),
    );
    nextStep();
  };

  return (
    <Spin spinning={loadStep2} size="large">
      <Wrapper>
        <div className="section">
          <div className="extraLargeFont">5. その他明細作成</div>
          <div className="table-data-user">
            <TableDataUser
              data={[...(otherDetail ?? []), ...listNew]}
              dataNew={listNew}
              setListNew={setListNew}
              statusBill={statusBill && statusBill.value === itemInvoice?.invoice_month}
            />
          </div>
          {statusBill && statusBill.value === itemInvoice?.invoice_month ? null : (
            <div className="add-statement">
              <div className="standardBoldFont text">明細を追加</div>
              <div>
                <Formik
                  onSubmit={handleSubmit}
                  initialValues={initialValues}
                  render={() => (
                    <Form layout="inline" className="form-add">
                      <Form.Item name="detail_name">
                        <p className=" label-select standardBoldFont">概要</p>
                        <Input size={'large'} style={{ width: 150 }} name="detail_name" />
                      </Form.Item>
                      <Form.Item name="other_detail_count">
                        <p className="label-select standardBoldFont">数量</p>
                        <Input type="number" style={{ width: 100 }} size="large" name="other_detail_count" />
                      </Form.Item>
                      <Form.Item name="other_detail_unit_price">
                        <p className="label-select standardBoldFont">単価</p>
                        <Input type="number" style={{ width: 100 }} size="large" name="other_detail_unit_price" />
                      </Form.Item>
                      <Form.Item name="other_detail_remark">
                        <p className="label-select standardBoldFont">備考</p>
                        <Input style={{ width: 442 }} size="large" name="other_detail_remark" />
                      </Form.Item>
                      <SubmitButton size={'large'} className="btn-sbm btn-add">
                        追加
                      </SubmitButton>
                    </Form>
                  )}
                />
              </div>
            </div>
          )}
          <div className="confirm-step">
            <Button onClick={stepToPrevious} className="btn-cancel-save">
              戻る
            </Button>
            <Button
              onClick={() => handleSubmitOther(statusBill?.value === itemInvoice?.invoice_month)}
              className="btn-save"
            >
              {statusBill?.value === itemInvoice?.invoice_month ? '次へ' : '保存して次へ'}
            </Button>
          </div>
        </div>
      </Wrapper>
    </Spin>
  );
};

const initialValues = {
  detail_name: '',
  other_detail_count: '',
  other_detail_unit_price: '',
  other_detail_remark: '',
};

export default BillingOtherFiveStep;
